import { useState, useEffect, useRef, useMemo, useCallback } from 'react';

// Mail gövdesi: script çalıştırmayan sandbox iframe.
// - Gelen mailin <img onerror=...> gibi içerikleri uygulamada (ve oturum token'ında) çalışamaz.
// - Mailin kendi CSS'i uygulamanın yerleşimini bozamaz.
export const EmailBody = ({ html, testId = 'mail-body-frame', padding = 16 }) => {
  const frameRef = useRef(null);
  const [height, setHeight] = useState(48);

  const srcDoc = useMemo(
    () => `<!doctype html><html><head><meta charset="utf-8">
<meta http-equiv="Content-Security-Policy" content="default-src * data: blob: 'unsafe-inline'; script-src 'none'; object-src 'none'; frame-src 'none'">
<base target="_blank">
<style>
html,body{margin:0;padding:0;background:#fff;color:#1f2937;font:14px/1.6 Inter,-apple-system,"Segoe UI",Roboto,sans-serif;word-wrap:break-word}
body{padding:${padding}px}
img{max-width:100%;height:auto}
a{color:#1769D6}
blockquote{margin:8px 0;padding-left:12px;border-left:3px solid #d1d5db;color:#4b5563}
</style></head><body>${html}</body></html>`,
    [html, padding],
  );

  const measure = useCallback(() => {
    const doc = frameRef.current?.contentDocument;
    if (!doc) return;
    // documentElement.scrollHeight iframe yüksekliğinden küçülemez; içeriği gövdeden ölç
    const body = doc.body;
    if (!body) return;
    setHeight(Math.max(body.scrollHeight, body.offsetHeight) + 2);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [measure]);

  const handleLoad = () => {
    measure();
    // Görseller geç yüklenince yükseklik değişir
    frameRef.current?.contentDocument?.querySelectorAll('img').forEach((img) => {
      img.addEventListener('load', measure);
    });
  };

  return (
    <iframe
      ref={frameRef}
      title="Mail içeriği"
      sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      srcDoc={srcDoc}
      onLoad={handleLoad}
      style={{ height }}
      className="block w-full border-0 bg-white"
      data-testid={testId}
    />
  );
};

export default EmailBody;
